import { useReducer } from "react";

const setStateReducer = (state, newState) => ({ ...state, ...newState });

export const useSetState = (initialState) => {
  const [state, dispatch] = useReducer(setStateReducer, initialState);
  const setState = (newState) => dispatch(newState);
  return [state, setState];
};
